import React, { useEffect, useState } from 'react';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import axios from 'axios';
import Authenticated from '@/Layouts/Authenticated';
import { Alert, Button, Modal } from 'react-bootstrap-v5'
import PaypalCard from '../Components/PaypalCard';

export default function Subscription(props) {
    const [subscription, setSubsciption] = useState(props.subscription)
    const [header, setHeader] = useState(props.header ?? '訂閱狀況')
    const [plans, setPlans] = useState([])
    const [updating, setUpdating] = useState(false)

    const [confirming, setConfirming] = useState(false)
    const [cancelling, setCancelling] = useState(false)
    const [cancelMessage, setCancelMessage] = useState(null)

    const paypalScriptOptions = {
        'client-id': props.clientId,
        'vault': true,
        'intent': 'subscription'
    };

    const paypalButtonStyle = {
        shape: 'rect',
        color: 'gold',
        layout: 'vertical',
        label: 'subscribe',
    }

    const createSubscription = (plan_id, actions) => {
        return actions.subscription.create({
            plan_id: plan_id,
            custom_id: props.auth.user.uid,
            subscriber: {
                email_address: props.auth.user.email,
            },
            application_context: {
                brand_name: props.app.name,
                shipping_preference: 'NO_SHIPPING',
            }
        })
    }

    const onApprove = async (data, plan_id) => {
        setUpdating(true)
        data.planID = plan_id
        const res = await axios.post(route('subscription.store'), data)

        setUpdating(false)
        setHeader('訂閱狀況')
        setSubsciption(res.data.subscription)
    }

    const confirmCancelSubscription = () => {
        setCancelMessage(null)
        setConfirming(true)
    }

    const cancelSubscription = async () => {
        setCancelMessage(null)
        setCancelling(true)

        const res = await axios.delete(route('subscription.destroy'))
        setCancelling(false)

        if (res.data.error) {
            setCancelMessage(res.data.error)
            return
        }

        setSubsciption(res.data.subscription)
        setConfirming(false)
    }

    useEffect(async () => {
        if (!subscription) {
            const res = await axios.get(route('subscription.plans'))
            setPlans(res.data)
        }
    }, [subscription])

    return (
        <Authenticated app={props.app} auth={props.auth}>
            <div className="category-title">
                <div className="container">
                    <h1>{header}</h1>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="container">
                    {subscription && (
                        <>
                            {subscription.subsciber_subscription_id ? (
                                <>
                                    <p>
                                        你的訂閱編號 {subscription.subsciber_subscription_id}
                                    </p>
                                    <p>
                                        你的訂閱到期日是 {subscription.subsciber_expiry_date}, 到期日會自動扣款續期, 如需取消自動續訂, 請在到期日前取消。
                                    </p>
                                    <p>
                                        <Button onClick={confirmCancelSubscription}>取消自動續訂</Button>
                                    </p>
                                </>
                            ) : (
                                <p>
                                    你的訂閱會在 {subscription.subsciber_expiry_date} 到期
                                </p>
                            )}
                        </>
                    )}

                    {updating && (
                        <Alert variant="info">
                            訂閱中...
                        </Alert>
                    )}

                    {!subscription && !updating && plans && (
                        <>
                            <PayPalScriptProvider options={paypalScriptOptions}>
                                <section className="section-cards">
                                    <div className="row gy-5">
                                        {plans.map(plan => (
                                            <PaypalCard key={plan.id} plan={plan}
                                                buttonStyle={paypalButtonStyle}
                                                createSubscription={createSubscription}
                                                onApprove={onApprove}
                                            />
                                        ))}
                                    </div>
                                </section>
                            </PayPalScriptProvider>

                            <p><small>
                                取消訂閱條款: 由訂閱日期起的六十日內, 你可退回訂閱及取回付款。<br />
                                Return policy: You can return the subscription and get the refund in 60 days after the subscription date.
                            </small></p>
                        </>
                    )}

                    {confirming && (
                        <Modal show={confirming} onHide={() => setConfirming(false)} style={{ top: '80px' }}>
                            <Modal.Header closeButton>
                                <Modal.Title>確認取消自動續訂</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>請確認取消自動付款續期訂閱</p>
                                {cancelling && (
                                    <Alert variant="info">
                                        取消中...
                                    </Alert>
                                )}
                                {cancelMessage && (
                                    <Alert variant="danger">
                                        {cancelMessage}
                                    </Alert>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setConfirming(false)}>關閉</Button>
                                <Button variant="primary" onClick={cancelSubscription} disabled={cancelling}>確認</Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                </div>
            </div>
        </Authenticated>
    );
}
